// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__cyF1v","right":"Footer_right__1NEW5","buttons":"Footer_buttons__Bccsm"};